/* NZ homepage hero — "Range Rotator" (C3). Auto-rotating scene + carousel controls.
   Section-scoped (no global ids) so it is safe with the Theme Editor and multiple instances.
   Reads ranges from a <script class="nz-hero-data" type="application/json"> the section emits.
   - Random starting scene each visit (unless the section disables it).
   - Auto-advance with a cross-fade (copy block + stage fade; the search box stays put).
   - Click an arrow/dot → jump + PAUSE auto-advance. Hover/focus inside the hero also pauses.
   - prefers-reduced-motion → no auto-advance, instant swaps. Zero deps; everything guarded. */
(function () {
  function initHero(root) {
    if (!root || root.dataset.nzHeroReady === '1') return;
    var dataEl = root.querySelector('.nz-hero-data');
    var T = [];
    try { T = JSON.parse(dataEl && dataEl.textContent || '[]') || []; } catch (e) { T = []; }
    if (!T.length) return;
    root.dataset.nzHeroReady = '1';

    /* Each slide carries `products` = that range's 90-day best-sellers. Pick a
       random one per slide on every load so each refresh surfaces a different
       best-seller per category (client-side, so it varies even if the HTML is
       edge-cached). De-dup across slides so no two show the same cross-listed
       product. Falls back to the slide's flat vendor/title/image if no pool. */
    (function pickProducts() {
      var usedH = {};
      /* assign most-constrained slides first (smallest pool) so a single-product
         slide claims its product before a widened slide can take it */
      var order = [];
      for (var i = 0; i < T.length; i++) order.push(i);
      order.sort(function (a, b) {
        return ((T[a].products && T[a].products.length) || 1) - ((T[b].products && T[b].products.length) || 1);
      });
      for (var oi = 0; oi < order.length; oi++) {
        var s = order[oi];
        var pool = T[s].products;
        if (!pool || !pool.length) continue;
        var start = Math.floor(Math.random() * pool.length);
        var chosen = pool[start];
        for (var j = 0; j < pool.length; j++) {
          var cand = pool[(start + j) % pool.length];
          if (!cand.handle || !usedH[cand.handle]) { chosen = cand; break; }
        }
        if (chosen.handle) usedH[chosen.handle] = 1;
        T[s].vendor = chosen.vendor;
        T[s].title = chosen.title;
        T[s].image = chosen.image;
        T[s].phref = chosen.handle ? '/products/' + chosen.handle : '';
      }
    })();

    var q = function (s) { return root.querySelector(s); };
    var elEyebrow = q('[data-nz-eyebrow]');
    var elH1      = q('[data-nz-h1]');
    var elLede    = q('[data-nz-lede]');
    var elCtaBtn  = q('[data-nz-cta]');
    var elCtaTxt  = q('[data-nz-cta-txt]');
    var elImg     = q('[data-nz-img]');
    var elPlink   = q('[data-nz-plink]');
    var chipEls   = root.querySelectorAll('.sc-chip');
    var elVendor  = q('[data-nz-vendor]');
    var elCapLbl  = q('[data-nz-caplabel]');
    var dotsWrap  = q('[data-nz-dots]');
    var prevBtn   = q('[data-nz-prev]');
    var nextBtn   = q('[data-nz-next]');
    var fadeEls   = root.querySelectorAll('.sc-fade');

    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var randomStart = root.dataset.nzRandom !== 'false';
    var INTERVAL = Math.max(2500, parseInt(root.dataset.nzInterval, 10) || 5500);
    var FADE = 260;
    var cur = 0, timer = null, paused = false;

    /* one dot per scene */
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var d = 0; d < T.length; d++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sc-hero__dot';
        b.setAttribute('data-i', d);
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Show ' + (T[d].eyebrow || ('range ' + (d + 1))));
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }

    function paint(i) {
      var t = T[i]; if (!t) return;
      if (elEyebrow) elEyebrow.textContent = t.eyebrow || '';
      if (elH1)      elH1.textContent = t.headline || '';
      if (elLede)    elLede.textContent = t.sub || '';
      if (elCtaTxt)  elCtaTxt.textContent = t.cta || 'Shop the range';
      if (elCtaBtn && t.url) elCtaBtn.setAttribute('href', t.url);

      /* floating feature chips — one per feature; hide empties, hide all if none */
      if (chipEls && chipEls.length) {
        var feats = t.features || [];
        for (var k = 0; k < chipEls.length; k++) {
          var chip = chipEls[k];
          var txt = k < feats.length ? feats[k] : '';
          if (!txt) { chip.style.display = 'none'; continue; }
          chip.style.display = '';
          if (chip.lastChild && chip.lastChild.nodeType === 3) chip.lastChild.nodeValue = txt;
          else chip.appendChild(document.createTextNode(txt));
        }
      }

      var vendor = t.vendor || 'Wellforces';
      if (elVendor) elVendor.textContent = vendor;
      if (elCapLbl) elCapLbl.textContent = vendor;

      if (elImg && t.image) {
        elImg.setAttribute('src', t.image);
        elImg.setAttribute('alt', t.title || ((t.eyebrow || 'Featured') + ' product'));
        if (elImg.hasAttribute('srcset')) elImg.removeAttribute('srcset');
      }

      if (elPlink) {
        if (t.phref) {
          elPlink.setAttribute('href', t.phref);
          elPlink.setAttribute('aria-label', 'View ' + (t.title || 'product'));
          elPlink.style.pointerEvents = '';
        } else {
          elPlink.removeAttribute('href');
          elPlink.style.pointerEvents = 'none';
        }
      }
    }

    function setActiveDot(i) {
      for (var k = 0; k < dots.length; k++) {
        var on = (k === i);
        dots[k].classList.toggle('is-active', on);
        dots[k].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }
    function fade(out) { for (var k = 0; k < fadeEls.length; k++) fadeEls[k].classList.toggle('is-out', out); }

    function setScene(i, instant) {
      i = ((i % T.length) + T.length) % T.length;
      cur = i;
      setActiveDot(i);
      if (instant || reduce) { paint(i); fade(false); return; }
      fade(true);
      window.setTimeout(function () { paint(i); fade(false); }, FADE);
    }
    function next() { setScene(cur + 1); }
    function prev() { setScene(cur - 1); }

    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function start() { stop(); if (reduce || paused || T.length < 2) return; timer = window.setInterval(next, INTERVAL); }
    function pauseAuto() { paused = true; stop(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { pauseAuto(); next(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { pauseAuto(); prev(); });
    if (dotsWrap) dotsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('.sc-hero__dot'); if (!b) return;
      pauseAuto();
      setScene(parseInt(b.getAttribute('data-i'), 10) || 0);
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    setScene(randomStart ? Math.floor(Math.random() * T.length) : 0, true);
    start();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-nz-hero]');
    for (var i = 0; i < nodes.length; i++) initHero(nodes[i]);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* Theme Editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-nz-hero]') : null;
    if (root) { root.dataset.nzHeroReady = ''; initHero(root); }
  });
})();
